var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 423 520",
    style: {
      enableBackground: "new 0 0 423 520"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st107{fill:#FFFFFF;stroke:#010101;stroke-width:3;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M258.2,415.38l-139.21-23.43c-32.09-5.4-53.72-35.79-48.32-67.88l37.07-220.28l255.41,42.99l-37.07,220.28 C320.68,399.15,290.29,420.78,258.2,415.38z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatch);
export default __webpack_public_path__ + "static/media/PATCH.67631a4ca40a56b16d201a1082d66b96.svg";
export { ForwardRef as ReactComponent };